// Sort strings such that "1" < "2" < "10"
export const naturalComparison = (a: string, b: string): number =>
  // Backend V8 and recent Chrome/Node seem to disagree on the `sensitivity` flag. We cheat by
  // casting all input to lowercase before comparison. We don't have a plain V8 test runner so
  // there's virtually no test case we can write to catch this.
  a.toLowerCase().localeCompare(b.toLowerCase(), undefined, {
    sensitivity: 'accent',
    numeric: true
  });
